"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEvent = exports.stop = exports.start = exports.init = void 0;
var VERSION_PLACEHOLDER = 'v1.1.3';
var SDK_URL = "https://www.saola.ai/sdk/saola.".concat(VERSION_PLACEHOLDER, ".js");
var win = window;
var initialized = false;
var init = function (accountToken, version, customOptions) {
    if (version === void 0) { version = 'latest'; }
    if (customOptions === void 0) { customOptions = {}; }
    if (initialized)
        return;
    setParams(accountToken, customOptions);
    injectSDK(version);
    initialized = true;
};
exports.init = init;
var start = function () {
    if (!win.Saola || !win.Saola.start)
        return;
    win.Saola.start();
};
exports.start = start;
var stop = function () {
    if (!win.Saola || !win.Saola.stop)
        return;
    win.Saola.stop();
};
exports.stop = stop;
var customEvent = function (eventType, data) {
    if (!win.Saola || !win.Saola.customEvent)
        return;
    win.Saola.customEvent(eventType, data);
};
exports.customEvent = customEvent;
var setParams = function (accountToken, customOptions) {
    if (customOptions === void 0) { customOptions = {}; }
    win.SaolaParams = { token: accountToken, options: customOptions };
};
var injectSDK = function (version) {
    var SDKScript = win.document.createElement('script');
    SDKScript.defer = true;
    SDKScript.src = SDK_URL.replace(VERSION_PLACEHOLDER, version);
    win.document.head.appendChild(SDKScript);
};
exports.default = exports.init;
